import React from 'react';
import Step, { StepType } from './step';
import { Url } from '.';

const PreviousStep:React.FC<{url?: Url}> = ({url}) => {
    return (
        <Step url={url} type={StepType.previous} />
    )
}

export default PreviousStep;